import React from 'react'

const MyFamily = () => {
  return (
    <div><p>Lorem500</p></div>
  )
}

export default MyFamily